// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"ResetPasswordForm_resetPasswordForm__KudAC","passwordContainer":"ResetPasswordForm_passwordContainer__BHH2-","eyeIcon":"ResetPasswordForm_eyeIcon__q5cy4"};